import { Fragment, Dispatch, SetStateAction, useEffect } from 'react'

import { useTranslation } from 'next-i18next'

import { range } from '~/utils/helpers'

import ResponsiveImage from '~/components/Image/ResponsiveImage'

export default function ChestSpriteImages({
  frame,
  imageHeight,
  imageWidth,
  setSpriteImageDidLoad,
  spriteCols,
  spriteRows,
  spriteHeight,
  spriteImageDidLoad,
  spriteWidth,
  spriteImgSrcKey = 'gamification/chests/FunfactChest_spritesheet_v4.png',
  className,
  enhanceSpriteSheet,
  enhanceSpriteSheetMultiplier = 1.5,
}: {
  frame: number
  imageHeight: number
  imageWidth: number
  setSpriteImageDidLoad: Dispatch<SetStateAction<boolean>>
  spriteCols: number
  spriteRows: number
  spriteHeight: number
  spriteImageDidLoad: boolean
  spriteWidth: number
  spriteImgSrcKey?: string
  className: string
  enhanceSpriteSheet?: boolean
  enhanceSpriteSheetMultiplier?: number
}): React.ReactElement {
  const { t } = useTranslation(['imageAlt'])
  const spriteColsArr = range(spriteCols)
  const spriteRowsArr = range(spriteRows)
  const spritePositions = spriteRowsArr.map((row) => spriteColsArr.map((col) => ({ row, col })))
  const mediaQuery = [{ screen: '(min-width: 280px)', width: `${spriteWidth}px` }]

  useEffect(() => {
    if (!spriteImageDidLoad) {
      setSpriteImageDidLoad(true)
    }
  }, [setSpriteImageDidLoad, spriteImageDidLoad])

  return (
    <Fragment>
      {spritePositions.flat().map(({ row, col }, index) => {
        const topPosition = `calc(-${imageHeight}px * ${row})`
        const leftPosition = `calc(-${imageWidth}px * ${col})`
        const imageNumber = index + 1

        return (
          <div
            className={`absolute inset-0 overflow-hidden ${frame === imageNumber ? 'block' : 'hidden'}`}
            key={`${row}-${col}`}
          >
            <ResponsiveImage
              alt={t('imageAlt:spriteSheet')}
              className={className}
              height={spriteHeight}
              imageClassName="absolute max-w-none !m-0"
              imageWidths={`${enhanceSpriteSheet ? spriteWidth * enhanceSpriteSheetMultiplier : spriteWidth}`}
              loading="eager"
              mediaQuery={mediaQuery}
              srcKey={spriteImgSrcKey}
              style={{ top: topPosition, left: leftPosition }}
              types={['webp']}
              width={spriteWidth}
            />
          </div>
        )
      })}
    </Fragment>
  )
}
